
import { credentials } from '@shootsta/client-auth';
import FileUploader from './FileUploader';
import {
  createAssets,
  getAssetFromLocalStorage,
  Queue,
  isAssetInLocalStorage,
  AssetUploaderHandlers } from
'../utils';

import { ITEM_STATUS } from '../constants';









function getAssetPayload({
  organisationId,
  file,
  metaData,
  hidden = false,
  isSystemAsset = false
}) {
  return {
    organisationId,
    title: file.name,
    filename: file.name,
    metaData,
    hidden,
    isSystemAsset
  };
}

class AssetUploader {




  _fileUploaders = {};

  getNewFileUploader = (params) => {
    const fileUploader = new FileUploader({
      addUploadTasksToQueue: this._queue.addUploadTasks,
      removeUploadTasksFromQueue: this._queue.removeUploadTasks,
      apiClient: this._apiClient,
      ...params
    });

    this._fileUploaders[params.assetId] = fileUploader;

    return fileUploader;
  };

  getNewHandlers = ({
    handleAssetUpdates,
    totalSize,
    asset




  }) => new AssetUploaderHandlers({
    handleAssetUpdates,
    onUploadComplete: this.destroyFileUploader(asset.assetId),
    asset,
    totalSize,
    apiClient: this._apiClient
  }).getHandlers();

  constructor(apiClient) {
    this._apiClient = apiClient;
    this._queue = new Queue();
  }

  createAssets = async (assets) =>
  createAssets(this._apiClient, assets.map(getAssetPayload));


  uploadAsset = async ({
    asset,
    handleAssetUpdates,
    file
  }) => {
    handleAssetUpdates([{
      ...asset,
      loaded: 0,
      loadedPercent: 0,
      totalSize: file.size,
      uploadStatus: ITEM_STATUS.DEFAULT
    }]);

    const handlers = this.getNewHandlers({ handleAssetUpdates, asset, totalSize: file.size });

    const {
      assetId,
      organisationId,
      metaData,
      assetFiles: { ORIGINAL }
    } = asset;

    this.getNewFileUploader({
      bucketKey: `organisation/${organisationId}/asset/${assetId}/file`,
      file,
      ORIGINAL,
      assetId,
      organisationId,
      metaData,
      ...handlers
    }).start();
  };

  destroyFileUploader = (assetId) => () => {
    const { [assetId]: uploader, ...uploaders } = this._fileUploaders;

    if (!uploader) {return;}

    uploader.destroy();

    this._fileUploaders = uploaders;
  };

  retryAssetUpload = async ({
    handleAssetUpdates,
    file,
    assetId,
    organisationId





  }) => {
    const localAsset = getAssetFromLocalStorage(assetId);

    if (!localAsset || !isAssetInLocalStorage(localAsset, file)) {return;}

    const { bucketKey, assetFiles, metaData } = localAsset;
    const { user } = credentials.get();
    const asset = {
      assetId,
      organisationId,
      assetFiles,
      metaData,
      filename: file.name,
      createdByUser: user,
      updatedByUser: user
    };
    handleAssetUpdates([asset]);

    const handlers = this.getNewHandlers({ handleAssetUpdates, asset, totalSize: file.size });

    handlers.progress(localAsset.uploadedBytes);

    this.getNewFileUploader({
      bucketKey,
      file,
      assetId,
      organisationId,
      ORIGINAL: assetFiles.ORIGINAL,
      metaData,
      cacheUploadId: localAsset.uploadId,
      uploadedParts: localAsset.uploadedParts,
      uploadedBytes: localAsset.uploadedBytes,
      ...handlers
    }).start();
  };

  cancelAssetUpload = ({ assetId }) => {
    this.destroyFileUploader(assetId)();
    this._queue.removeUploadTasks(assetId);
  };
}

export default AssetUploader;